// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filters-container[data-v-3cc1c7cc]{display:flex;flex-flow:row wrap;align-items:center;padding:.5rem 1rem}.filters-container>div[data-v-3cc1c7cc]{margin:0 .15rem .15rem .15rem!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
